const dataTeam = [
  {
    id: 1,
    img: "/images/t-1.webp",
    alt: "TEAM-MEMBER",
    name: "Jander Durham",
    text: "TEAM MEMBER",
  },
  {
    id: 2,
    img: "/images/t-2.webp",
    alt: "TEAM-MEMBER",
    name: "Jaren Hammer",
    text: "TEAM MEMBER",
  },
  {
    id: 3,
    img: "/images/t-3.webp",
    alt: "TEAM-MEMBER",
    name: "Nurdan Denkel",
    text: "TEAM MEMBER",
  },
  {
    id: 4,
    img: "/images/t-4.webp",
    alt: "TEAM-MEMBER",
    name: "Monroe Bond",
    text: "TEAM MEMBER",
  },
];

export default dataTeam;
